// src/app/config.ts

// 🌟 این سوییچ تعیین می‌کند روی لوکال هستی یا سرور
const useLocal = false;   // لوکال: true | سرور: false

// -------------------- Backend --------------------
const serverBackend = 'https://portal.mr-develop.ir/api';
const localBackend  = 'http://localhost:3000/api';

// -------------------- Keycloak --------------------
// نکته: url کیکلاک باید ریشه باشد (بدون /admin و بدون /realms)
const serverKeycloakUrl = 'https://auth.mr-develop.ir';
const localKeycloakUrl  = 'http://localhost:8080';

// realm و clientId بر اساس چیزی که در Keycloak ساختی
const keycloakRealm    = 'admin-panel';
const keycloakClientId = 'admin-ui';

export const config = {
  // Backend
  apiUrl: useLocal ? localBackend : serverBackend,
  apiAuthUrl: useLocal ? `${localBackend}/auth` : `${serverBackend}/auth`,

  // Keycloak
  keycloak: {
    url: useLocal ? localKeycloakUrl : serverKeycloakUrl,
    realm: keycloakRealm,
    clientId: keycloakClientId,

    // اگر خواستی بعداً مستقیم اینجا redirect/logout هم داشته باشی:
    portalUrl: useLocal ? 'http://localhost:4200' : 'https://portal.mr-develop.ir',
  },
};